import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { ChartViewDTO } from "../../model/chart_view/chart-view-dto";
import { QuantiteDossierSuiviPortefeuilleRisqueDTO } from "../../model/QuantiteDossierSuiviPortefeuilleRisqueDTO";
import { QuantiteDossierParMarcheEntrePeriodeDTO } from "../../model/QuantiteDossierParMarcheEntrePeriodeDTO";

@Injectable({
  providedIn: "root"
})
export class DashboardPortefeuilleRisqueService {
  constructor(private _restClientService: RestClientService) {}

  nombrePortefeuilleRisqueFiltrerSurPeriode() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-portefeuille-risque/nombre-dossier-portefeuille-risque-Filtrer-surPeriode"
    );
  }

  quantitePortefeuilleRisqueSurLes6DerniersMois() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-portefeuille-risque/quantite-dossier-portefeuille-risque-surLes6DerniersMois"
    );
  }

  quantiteDossierSuiviPortefeuilleRisque() 
  {
    return this._restClientService.load<QuantiteDossierSuiviPortefeuilleRisqueDTO>("dashboard-portefeuille-risque/nombre-dossier-portefeuille-risque");
  }

  pourcentageDossierPortefeuilleRisqueByTypeMarche(typeMarche) {
    return this._restClientService.load<any[]>(
      "dashboard-portefeuille-risque/pourcentage-dossier-by-type-marche?typeMarche="+typeMarche);
  }

  quantiteDossierParMarcheEntrePeriodeDTO() {
    return this._restClientService.load<QuantiteDossierParMarcheEntrePeriodeDTO[]>("dashboard-portefeuille-risque/quantite-dossier-par-marche-par-periode");
  }
}
